import type { AppLinksInterceptorComponent } from "hub/src/context/AppLinksInterceptor/types";

export const WebPlatformAppLinksInterceptor: AppLinksInterceptorComponent = ({
  children,
}) => {
  return <>{children}</>;
};
